import * as React from "react";

const SvgAuto = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 5v13h6v2H4.8A1.8 1.8 0 0 1 3 18.2V4.8A1.8 1.8 0 0 1 4.8 3h13.4A1.8 1.8 0 0 1 20 4.8V11h-2V5zm11.09 15.56.179 1.44h2.462l.18-1.44q.134-.055.268-.135.135-.08.258-.169l1.32.563 1.232-2.138-1.153-.877a.6.6 0 0 0 .022-.152v-.304q0-.074-.011-.152L22 16.32l-1.231-2.138-1.332.563a4 4 0 0 0-.252-.169 1.7 1.7 0 0 0-.275-.135L18.731 13H16.27l-.18 1.44q-.134.056-.268.135t-.258.169l-1.332-.563L13 16.32l1.153.877a1 1 0 0 0-.011.152v.304q0 .074.011.152L13 18.68l1.231 2.138 1.332-.563q.123.09.252.169.13.079.275.135m2.54-1.946a1.5 1.5 0 0 1-1.108.461q-.66 0-1.113-.461a1.53 1.53 0 0 1-.454-1.114q0-.652.454-1.114a1.5 1.5 0 0 1 1.113-.461q.65 0 1.109.461.459.462.459 1.114t-.46 1.114m-1.583-.636q.195.197.475.197a.65.65 0 0 0 .476-.197.65.65 0 0 0 .196-.478.65.65 0 0 0-.196-.478.65.65 0 0 0-.476-.197.65.65 0 0 0-.475.197.65.65 0 0 0-.196.478q0 .282.196.478m.89 3.122h-.885l-.145-1.193a2.487 2.487 0 0 1-1.187-.697l-1.108.473-.437-.765.963-.732a2 2 0 0 1-.078-.337 2.745 2.745 0 0 1 0-.709 2 2 0 0 1 .078-.338l-.963-.72.437-.764 1.108.46q.246-.246.543-.421a2.5 2.5 0 0 1 .644-.264l.156-1.193h.885l.145 1.192a2.487 2.487 0 0 1 1.187.697l1.108-.471.437.765-.963.73q.056.158.078.333a2.8 2.8 0 0 1 0 .708 1.6 1.6 0 0 1-.078.332l.963.732-.437.765-1.108-.462a2.7 2.7 0 0 1-.543.422 2.5 2.5 0 0 1-.644.264z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAuto;
